module.exports = __webpack_public_path__ + "static/media/Inter-ExtraBoldItalic.d47b5861.woff2";